import slugify from '../src/slugify.ts';
export default slugify;
